var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sabo-help-box" }, [
    _c(
      "span",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip.click",
            value: {
              html: _vm.messageRef,
              class: "tooltip-custom tooltip-other-custom"
            },
            expression:
              "{ html: messageRef, class: 'tooltip-custom tooltip-other-custom' }",
            modifiers: { click: true }
          }
        ]
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: _vm.messageRef } }, [
      _c("div", {}, [
        _c("h3", { staticClass: "popover-title" }, [
          _vm._v(
            "\n                " + _vm._s(_vm.title) + "\n                "
          ),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "popover-content",
          domProps: { innerHTML: _vm._s(_vm.message) }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help-box" }, [
      _c(
        "button",
        {
          staticClass: "btn btn--round help-box-button",
          attrs: { type: "button", title: "" }
        },
        [_c("span", [_vm._v(" i ")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn--none help-box-close",
        attrs: { type: "button" }
      },
      [
        _c("span", {
          staticClass: "spinner spinner--black glyphicon glyphicon-remove"
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/saboHelpBox.vue?vue&type=template&id=6b9d0456&
// module id = 504
// module chunks = 0